export const PATH_ADMIN = 'admin';

export const PATH_CENTER_ADMINSTRATION = 'center-administraion';
export const PATH_USERS = 'users';
export const PATH_ENTITIES = 'entities';
export const ROUTE_ADMIN_CA_USERS = `/${PATH_ADMIN}/${PATH_CENTER_ADMINSTRATION}/${PATH_USERS}`;
export const ROUTE_ADMIN_CA_ENTITIES = `/${PATH_ADMIN}/${PATH_CENTER_ADMINSTRATION}/${PATH_ENTITIES}`;

export const PATH_SYSTEM_ADMINSTRATION = 'system-administraion';
export const PATH_CENTERS = 'centers';
export const PATH_ROLES = 'roles';

export const PATH_PMP_INVOICES = 'pmp-invoices';
export const PATH_SURVEY = 'survey';

export const ROUTE_ADMIN_SA_CENTERS = `/${PATH_ADMIN}/${PATH_SYSTEM_ADMINSTRATION}/${PATH_CENTERS}`;
export const ROUTE_ADMIN_SA_ROLES = `/${PATH_ADMIN}/${PATH_SYSTEM_ADMINSTRATION}/${PATH_ROLES}`;
